import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { IntlProvider } from 'react-intl';
import translations from '@nike/gameday-translations/web';

import { getUserData } from '../user/selectors';

const WithTranslations = ({ user, children }) => {
  const lang = (user?.locale || 'en')?.replace(/_.*$/, '');

  return (
    <IntlProvider locale={lang} messages={translations[lang]}>
      {children}
    </IntlProvider>
  );
};

const mapStateToProps = state => ({
  user: getUserData(state)
});

WithTranslations.propTypes = {
  user: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired
};

const connector = connect(mapStateToProps);

export default connector(WithTranslations);
